import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../atoms';
import { RoutePath } from '../../config';

type TwoFactorAuthDialogProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const TwoFactorAuthDialog = ({ isOpen, onClose }: TwoFactorAuthDialogProps) => {
  const navigate = useNavigate();

  const handleNavigateTo2FA = () => {
    navigate(RoutePath.Enable2FA);
    onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-[400px] max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                  2FA Required
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Please activate 2FA to complete operation</p>
                </div>

                <div className="mt-4 flex flex-col gap-2">
                  <a
                    href={RoutePath.Enable2FA}
                    onClick={handleNavigateTo2FA}
                    className="text-sm text-blue-600 hover:text-blue-800 underline"
                  >
                    Включить 2FA
                  </a>
                  <Button onClick={onClose}>Закрыть</Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

